module.exports = __webpack_public_path__ + "static/media/goldenIllustration.7c10a874.png";